import { render, staticRenderFns } from "./CibButton.vue?vue&type=template&id=086d27ed&"
import script from "./CibButton.vue?vue&type=script&lang=ts&"
export * from "./CibButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports